export const LOGMEIN = 'LOGMEIN';
export const SET_AUTH = 'SET_AUTH';
export const CLEAR_DATA = 'CLEAR_DATA';
export const SET_USER_ID = 'SET_USER_ID';

